(() => {
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Set();
  const vertex = `
    attribute vec2 point;
    varying vec2 uv;
    uniform float time;
    uniform float strength;
    uniform float direction;
    void main() {
      uv = point;
      vec2 p = point;
      // Two exposed foliage regions. The beaver and lettering have zero weight.
      float left = smoothstep(.035,.085,p.x)*(1.-smoothstep(.17,.215,p.x));
      left *= 1.-smoothstep(.24,.47,p.y);
      float right = smoothstep(.335,.375,p.x)*(1.-smoothstep(.44,.475,p.x));
      right *= 1.-smoothstep(.23,.46,p.y);
      float a = sin(time*2.5) * .025 + sin(time*4.1)*.008;
      float b = sin(time*2.5-.75) * .032 + sin(time*3.7)*.006;
      p.x += strength*(left*a + right*b)*direction;
      p.y += strength*(left*sin(time*2.5)*.009 + right*sin(time*2.5-.75)*.012);
      gl_Position = vec4(p.x*2.-1., 1.-p.y*2., 0., 1.);
    }`;
  const fragment = `precision mediump float; varying vec2 uv; uniform sampler2D artwork;
    void main(){gl_FragColor=texture2D(artwork,uv);}`;
  function setup(root = document) {
    root.querySelectorAll('[data-bk-brand-mark]').forEach(mark => {
      if (mark.dataset.bkMotionReady) return;
      mark.dataset.bkMotionReady = 'true';
      const img = mark.querySelector('img');
      let canvas, gl, uniforms, texture, buffer, program, ready = false, failed = false;
      let frame = 0, inside = false, start = 0, direction = 1, desired = 1;
      function stop() {
        inside = false; cancelAnimationFrame(frame); frame = 0;
        mark.classList.remove('bk-mark--active');
      }
      function permitted() { return fine.matches && !reduced.matches && !document.hidden && mark.isConnected; }
      function draw(now) {
        if (!inside || !permitted()) return stop();
        direction += (desired-direction)*.07;
        const seconds = (now-start)/1000;
        gl.uniform1f(uniforms.time,seconds);
        gl.uniform1f(uniforms.strength,Math.min(seconds/.35,1));
        gl.uniform1f(uniforms.direction,direction);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.drawArrays(gl.TRIANGLES,0,96*36*6);
        mark.classList.add('bk-mark--active');
        frame=requestAnimationFrame(draw);
      }
      async function prepare() {
        if (canvas || failed) return;
        canvas=document.createElement('canvas');
        canvas.setAttribute('aria-hidden','true');
        gl=canvas.getContext('webgl',{alpha:true,premultipliedAlpha:false,antialias:true});
        if (!gl) { failed=true; return; }
        canvas.addEventListener('webglcontextlost',event=>{event.preventDefault();failed=true;stop();});
        try {
          const source=new Image(); source.crossOrigin='anonymous'; source.src=img.currentSrc||img.src;
          await source.decode();
          if(!mark.isConnected)return;
          function shader(type,code){const s=gl.createShader(type);gl.shaderSource(s,code);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS)){gl.deleteShader(s);throw Error('shader');}return s;}
          program=gl.createProgram();
          const vs=shader(gl.VERTEX_SHADER,vertex),fs=shader(gl.FRAGMENT_SHADER,fragment);
          gl.attachShader(program,vs);gl.attachShader(program,fs);gl.linkProgram(program);gl.deleteShader(vs);gl.deleteShader(fs);
          if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error('program');
          gl.useProgram(program);
          const points=[];
          for(let y=0;y<36;y++)for(let x=0;x<96;x++){
            const a=x/96,b=y/36,c=(x+1)/96,d=(y+1)/36;
            points.push(a,b,c,b,a,d,a,d,c,b,c,d);
          }
          buffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(points),gl.STATIC_DRAW);
          const location=gl.getAttribLocation(program,'point');gl.enableVertexAttribArray(location);gl.vertexAttribPointer(location,2,gl.FLOAT,false,0,0);
          texture=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,texture);
          gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
          gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
          gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,source);
          uniforms={time:gl.getUniformLocation(program,'time'),strength:gl.getUniformLocation(program,'strength'),direction:gl.getUniformLocation(program,'direction')};
          gl.uniform1i(gl.getUniformLocation(program,'artwork'),0);
          mark.append(canvas);ready=true;
          if(inside&&permitted())play();
        } catch (_) {failed=true;stop();}
      }
      function play() {
        if(!permitted()||failed)return;
        inside=true;
        if(!ready){prepare();return;}
        if(frame)return;
        const rect=mark.getBoundingClientRect(),ratio=Math.max(2,Math.min(devicePixelRatio||1,3));
        canvas.width=Math.round(rect.width*ratio);canvas.height=Math.round(rect.height*ratio);
        gl.viewport(0,0,canvas.width,canvas.height);
        start=performance.now();frame=requestAnimationFrame(draw);
      }
      function move(event){if(!permitted())return;const rect=mark.getBoundingClientRect();desired=.75+Math.max(0,Math.min(1,(event.clientX-rect.left)/rect.width))*.6;play();}
      const controller={stop,destroy(){stop();if(gl){gl.deleteTexture(texture);gl.deleteBuffer(buffer);gl.deleteProgram(program);gl.getExtension('WEBGL_lose_context')?.loseContext();}controllers.delete(controller);}};
      controllers.add(controller);
      // Hover is limited to the artwork's box, not the surrounding header link.
      mark.addEventListener('pointerenter',play);
      mark.addEventListener('pointermove',move);
      mark.addEventListener('pointerleave',stop);
      mark.addEventListener('wheel',event=>{if(inside)desired=event.deltaY<0?-1.15:1.15;},{passive:true});
      controller.element=mark;
    });
  }
  const stopAll=()=>controllers.forEach(c=>c.stop());
  fine.addEventListener('change',stopAll);reduced.addEventListener('change',stopAll);
  document.addEventListener('visibilitychange',stopAll);window.addEventListener('resize',stopAll);
  document.addEventListener('shopify:section:unload',event=>controllers.forEach(c=>{if(event.target.contains(c.element))c.destroy();}));
  document.addEventListener('shopify:section:load',event=>setup(event.target));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
})();
